import style from './style.scss';

/**
 * The DataLine component is a small helper component for displaying
 * a line of data in the primary live data view on the home page.
 *
 * props:
 * - label: The label for this piece of data
 * - value: The data value
 * - unit: The unit associated with this piece of data (formatted for display)
 */

const DataLine = props => (
	<div class={style.data_line}>
		<span class={style.data_label}>{ props.label }:</span>
		<span class={style.data_value}>
			{ props.value }
			<span class={style.shrink_unit}>{ props.unit }</span>
		</span>
	</div>
);

export default DataLine;



// WEBPACK FOOTER //
// ./components/live/data-line.js